import { createEditorContentUnifiedQueryVariables } from '@confluence/editor-content-unified-query/entry-points/createEditorContentUnifiedQueryVariables.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import CoverPictureQuery, {
	type CoverPictureQuery$data,
	type CoverPictureQuery$variables,
} from '../__generated__/CoverPictureQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export function preloadEditorPageCoverPicture(
	contentId: CoverPictureQuery$variables['contentId'],
	draftShareId: CoverPictureQuery$variables['draftShareId'],
	useCache: boolean,
): Promise<{
	data: CoverPictureQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<CoverPictureQuery$data, CoverPictureQuery$variables>({
		query: CoverPictureQuery,
		variables:
			contentId && expValEquals('confluence_editor_content_unified_query', 'isEnabled', true)
				? createEditorContentUnifiedQueryVariables({ contentId, draftShareId })
				: {
						contentId,
						status: ['current', 'draft'],
						draftShareId,
					},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
